export const getters = {
  permissions: state => state.permissions
}

export default getters



// WEBPACK FOOTER //
// ./src/store/module/permission/getters.js